import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayIncludes',
  standalone: true,
})
export class ArrayIncludesPipe implements PipeTransform {
  public transform<T>(array: T[], value: T, _changeDetectionParam: unknown = array.length): boolean {
    return array.includes(value);
  }
}
